// extracted by mini-css-extract-plugin
module.exports = {"table__actions":"Residents_table__actions__q1erh"};